import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-connect-social-bar',
  templateUrl: './connect-social-bar.component.html',
  styleUrls: ['./connect-social-bar.component.scss']
})
export class ConnectSocialBarComponent  {
  @Input() web?: string;
  @Input() facebook?: string;
  @Input() twitter?: string;
  @Input() instagram: string;
  @Input() name?: string;
  @Input() pinterest?: string;
  @Input() linkedIn?: string;

  constructor() { }

  private _strippedWebLink: string;
  get strippedWebLink(): string {
    // Strip the extra characters like https out
    //
    if (!this._strippedWebLink) {
      this._strippedWebLink = this.web ? this.web.replace(/^\/\/|^.*?:(\/\/)?/, '') : '';
    }
    return this._strippedWebLink;
  }
}
